import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';

import { MatterStoreService } from '../../../services/matters/matter-store.service';

@Component({
  selector: 'app-matter-sidebar',
  templateUrl: './matter-sidebar.component.html',
  styleUrls: ['./matter-sidebar.component.css'],
})
export class MatterSidebarComponent implements OnInit, OnDestroy {
  @Input() loadingMatterPage: boolean = false;

  @Input() matter_id: number;

  @Input() permissions: any = {};

  @ViewChild('sidebarRecordTime', { static: true }) sidebarRecordTimeElement: ElementRef;
  @ViewChild('sidebarDocument', { static: true }) sidebarDocumentElement: ElementRef;

  sidebarExpand: any = {
    record_time: true,
  };

  constructor(private matterStoreService: MatterStoreService) {
    this.matterStoreService.matterSidebarComponent = this;
  }

  // Component lifecycle methods
  ngOnInit() {}

  ngOnDestroy() {
    this.matterStoreService.matterSidebarComponent = null;
  }

  matterEditFormSaveEventHander($event: any) {
    if($event.status){
      this.sidebarExpand.edit_matter = !(this.sidebarExpand.edit_matter)
    }
  }

}
